import React from 'react';
import { Alert, Link } from '@mui/material';
import { COLOR_PRIMARY_2 } from 'src/colors';

export const UpgradeAlertStarterToExpert = ({
  handleOnSampleClick,
}: {
  handleOnSampleClick: any;
}) => {
  return (
    <>
      <Alert severity="warning" sx={{ mb: '20px' }}>
        You’ve reached the Starter plan limit for Saved Markets.{' '}
        <span
          style={{ cursor: 'pointer', color: COLOR_PRIMARY_2, textDecoration: 'underline' }}
          onClick={() => handleOnSampleClick('expert')}
        >
          Upgrade to Expert Plan
        </span>{' '}
        to save and track up to 20 markets.
      </Alert>
    </>
  );
};

export const UpgradeAlertExpertToScale = ({
  handleOnSampleClick,
}: {
  handleOnSampleClick: any;
}) => {
  return (
    <>
      <Alert severity="warning" sx={{ mb: '20px' }}>
        You’ve reached the Expert plan limit for Saved Markets.{' '}
        <span
          style={{ cursor: 'pointer', color: COLOR_PRIMARY_2, textDecoration: 'underline' }}
          onClick={() => handleOnSampleClick('scale')}
        >
          Upgrade to Scale Plan
        </span>{' '}
        to create unlimited lists and save up to 100 markets per list.
      </Alert>
    </>
  );
};
